module.exports = __webpack_public_path__ + "img/line.1366b29d.jpg";